export default "__VITE_ASSET__DElsF31v__"